import React, { useEffect, useRef, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import { SvgImages } from "../../Utils/LocalImages";
import { ImageFilters } from "../../Utils/Enums";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from '../../Components/Reusable/CustomTextArea';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import BlogService from "../../Services/BlogService";
import { toast } from "react-toastify";
import RoutesPath from "../../Utils/RoutesPath";
import AutherService from "../../Services/AuthorService";
import CustomTextEditor from "../../Components/Reusable/CustomTextEditor";


const Blog = () => {
  const [category, setCategory] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [blog, setBlog] = useState({ ...useLocation().state });
  const [uploadedDocuments, setUploadedDocuments] = useState(Array());
  const [uploadedDocuments1, setUploadedDocuments1] = useState(Array());

  const fileInputRef = useRef(null);

  const navigate = useNavigate();

  const Validations = yup.object().shape({
    category_id: validationRegex.required,
    author_id: validationRegex.required,
    date: validationRegex.required,
    title: validationRegex.required,
    briefIntro: validationRegex.required,
    details: validationRegex.required,
    featuredImage: validationRegex.required,
    mainImage: validationRegex.required,
  });

  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    formState: { errors: errors },
    getValues: getValues,
    reset: reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      category_id: blog?.category_id || "",
      author_id: blog?.author_id || "",
      date: blog?.date || "",
      title: blog?.title || "",
      briefIntro: blog?.briefIntro || "",
      details: blog?.details || "",
      featuredImage: blog?.featuredImage || "",
      mainImage: blog?.mainImage || "",
    },
  });

  const onSubmit = async (blogData) => {
    try {
      // Call BlogService to add the blog
      const response = await BlogService.addBlog(
        blog?.blog_id || "",
        blogData.category_id,
        blogData.author_id,
        blogData.date,
        blogData.details,
        blogData.title,
        blogData.briefIntro,
        blogData.featuredImage === "[object FileList]" ? uploadedDocuments : blogData.featuredImage,
        blogData.mainImage === "[object FileList]" ? uploadedDocuments1 : blogData.mainImage

      );
      toast.success(response.message);
      navigate(RoutesPath.viewBlog);
      setBlog({})
    } catch (error) {
      // Handle API errors
      handleApiErrors(error);
      toast.error("Failed to add blog. Please try again later.");
    }
  };

  const getAllcategory = async () => {
    try {
      const response = await BlogService.getAllCategoryWithoutPagination();
      setCategory(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const getAllAuthers = async () => {
    try {
      const response = await AutherService.getAllAuthorsWithoutPagination();
      setAuthors(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    var date = new Date(blog.date);
    if (blog) {
      setValues("category_id", blog?.category_id || "");
      setValues("author_id", blog?.author_id || "");
      setValues("date", date.toLocaleDateString("sv-SE") || "");
      setValues("title", blog?.title || "");
      setValues("briefIntro", blog?.briefIntro || "");
      setValues("details", blog?.details || "");
      setValues("featuredImage", blog?.featuredImage || "");
      setValues("mainImage", blog?.mainImage || "");
    }
  }, [blog, setValues]);

  useEffect(() => {
    getAllcategory();
    getAllAuthers();
  }, []);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">BLOG PAGE</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Blog Page</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {blog.author_id ? "Edit" : ""} Blog
            </h1>
            {/* <div className="d-flex gap-4 align-items-center">
              <div className="position-relative">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search"
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>
              {!blog?.blog_id ? (
                <ButtonWithIcon text={"Add Blog"} icon={SvgImages.plus} />
              ) : (
                ""
              )}
            </div> */}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row profile_inputs w-100 mt-5">
              <div className="col-md-6">
            
                  <CustomDropDown
                    labelTitle="Select Category"
                    placeholder="Select"
                    name="category_id"
                    id="category_id"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    showMandatory={true}
                    setValue={setValues}
                    showError={errors?.category_id}
                    errorMessage={errors?.category_id?.message}
                    options={category?.map((e) => {
                      return { value: e._id, label: e.categoryName };
                    })}
                    defaultOption={() => {
                      return blog.category_id ? { value: blog.category_id, label: blog.categoryName } : null
                    }}
                  />
          
              </div>
              <div className="col-md-6">
              
                  <CustomDropDown
                    labelTitle="Author Name"
                    placeholder="Select"
                    name="author_id"
                    id="author_id"
                    inputType={InputType.text}
                    showMandatory={true}
                    setValue={setValues}
                    showError={errors?.author_id}
                    errorMessage={errors?.author_id?.message}
                    options={authors?.map((e) => {
                      return { value: e._id, label: e.name };
                    })}
                    defaultOption={() => {
                      return blog.author_id ? { value: blog.author_id, label: blog.name } : null
                    }}
                  />
            
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Date"
                  placeholder="Enter date"
                  name="date"
                  id="date"
                  showError={errors?.date}
                  errorMessage={errors?.date?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  inputType="date"
                  showMandatory={true}
                />
              </div>

              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Blog Title"
                  placeholder="Blog Title"
                  name="title"
                  id="title"
                  additionalClasses="profile_edit"
                  setValue={setValues}
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.title}
                  errorMessage={errors?.title?.message}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="login_heading">Featured Image<span className="danger fs-14 fw-400 mt-1">*(Extension: jpg. jpeg.webp) Note:Dimension Size 1000x600 px</span></label>
                <div className="position-relative select_file ">

                  <input className="choose-file"

                    type="file"
                    name="featuredImage"
                    id="featuredImage"
                    setValue={setValues}
                    accept="image/jpeg, image/jpg, image/webp"
                    // placeholder="No file chosen"
                    {...register("featuredImage")}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        const file = e.target.files[0];
                        const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                        if (!validTypes.includes(file.type)) {
                          toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                          e.target.value = null; // Clear the input value
                        } else {
                          setUploadedDocuments(file);
                        }
                      }
                    }}
                  />
                  {blog.featuredImage && (
                    <p className="text-success fs-14 fw-400 mt-1">Selected file: {blog.featuredImage}</p>
                  )}
                  {errors.featuredImage && (
                    <p className="danger fs-14 fw-400 mt-1">{errors.featuredImage.message}</p>
                  )}
                </div>

              </div>
              <div className="col-md-6 mb-3">
                <label className="login_heading">Main Image<span className="danger fs-14 fw-400 mt-1">*(Extension: jpg. jpeg.webp) Note:Dimension Size 1000x600 px</span></label>
                <div className="position-relative select_file ">

                  <input
                    type="file"
                    name="mainImage"
                    id="mainImage"
                    className="choose-file"
                    accept="image/jpeg, image/jpg, image/webp"
                    // placeholder="No file chosen"
                    {...register("mainImage", {
                      required: true,
                      message: "this is required",
                    })}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        const file = e.target.files[0];
                        const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                        if (!validTypes.includes(file.type)) {
                          toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                          e.target.value = null; // Clear the input value
                        } else {
                          setUploadedDocuments1(file);
                        }
                      }
                    }}
                  />
                  {blog.mainImage && (
                    <p className="text-success fs-14 fw-400 mt-1">Selected file: {blog.mainImage}</p>
                  )}
                  {errors.mainImage && (
                    <p className="danger fs-14 fw-400 mt-1">{errors.mainImage.message}</p>
                  )}
                </div>

              </div>
              <div className="col-md-12">
                <CustomTextArea
                  labelTitle="Brief Intro"
                  placeholder="File Name"
                  name="briefIntro"
                  id="briefIntro"
                  inputType={InputType.text}
                  showMandatory={true}
                  setValue={setValues}
                  register={register}
                  additionalClasses="brief_input"
                  showError={errors?.briefIntro}
                  errorMessage={errors?.briefIntro?.message}
                />
              </div>
              <div className="col-md-12">
                <CustomTextEditor
                  labelTitle="Details"
                  placeholder="File Name"
                  name="details"
                  id="details"
                  inputType={InputType.text}
                  showMandatory={true}
                  setValue={setValues}
                  register={register}
                  additionalClasses="brief_input"
                  showError={errors?.details}
                  errorMessage={errors?.details?.message}
                  defaultValue={blog?.details || ""}
                />
              </div>
              <div className="d-flex justify-content-end">
                <ButtonWithIcon
                  text={blog?.blog_id ? "Update" : "Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Blog;
